import { Column } from "primereact/column";
import CmsService from "../../../service/CmsService";
import GenericGrid from "../../common/GenericGrid";
import { useEffect, useInsertionEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataGrid from "../../common/DataGrid";
import CatTreeSelect from "../../cat/CatTreeSelect";
import { Toolbar } from "primereact/toolbar";
import { CrtDialog } from "./CrtForm";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";


export function CrtGrid(){
    const {t}=useTranslation();
    let nav = useNavigate();
 	const commandMenuItems = [
        {label: t('Edit'), icon: 'pi pi-pencil', actionName: 'edit',command:()=>{contextAction('edit')}},
        {label: t('Create_Test'), icon: 'pi pi-cog', actionName: 'create',command:()=>{contextAction('create')}},
    ]

    const [reload,setReload]=useState(false);
    const [selectedCrts,setSelectedCrts]=useState([]);
    const [crts,setCrts]=useState([]);
    const [catId,setCatId]=useState(0);
    const [crtDialog,setCrtDialog]=useState(false);

    const loadRecords=(cid)=>{
        if(cid == undefined) cid=catId;
        if(cid == 0)
            return;
        CmsService.getCrts(cid).then((recs)=>{
            setCrts(recs);
            setReload(false);
        })
    }
    const contextAction=(action,rec)=>{
		if(action == 'edit')
			onEdit(rec);
        if(action == 'create')
			createTest(rec);
    }	
    const onEdit=(rec)=>{
        nav('/itembank/crt/'+rec.id);
    }
    const onInsert=()=>{
        setCrtDialog(true);
    }
    const onCrtDialogOK=(crt)=>{
        setCrtDialog(false);
        nav('/itembank/crt/'+crt.id);        
    }
    const onCrtDialogCancel=()=>{
        setCrtDialog(false);
    }

    const onDeleteRecords=(ids)=>{
        return CmsService.deleteTemp(ids[0]);
    }
    const onCatSelect=(cat)=>{
        setCatId(cat.id);
        loadRecords(cat.id);
    }
    const filterBarStart=()=>{
        return (
            <div className="w-full">
                <CatTreeSelect parentId={0} value={catId} onSelect={onCatSelect} catType="COURSE"/>
            </div>
        );
    }
    const createTest=(crt)=>{
        nav('/itembank/crt/'+crt.id+'/select');
    }
    useEffect(()=>{
        loadRecords();
    },[]);
    const commandAction=(cmd)=>{}
    return(
        <>
            <div className="p-toolbar">{filterBarStart()}</div>
            <DataGrid reload={reload} recs={crts} loadRecords={loadRecords} selectedRecs={selectedCrts} 
                    setRecs={setCrts} setSelectedRecs={setSelectedCrts}
                    insertRecord={onInsert} deleteRecords={onDeleteRecords} contextMenuAsDropdown 
                    contextMenuItems={commandMenuItems} contextAction={contextAction}                                
                    parentId={0} insertMenu deleteMenu contextMenu t={t}> 
                <Column header={t("Id")} field="id" style={{width:'10%'}} sortable/>
                <Column header={t("Path")} field="path" style={{width:'20%'}} sortable/>
                <Column header={t("Name")} field="name" style={{width:'50%'}} sortable/>                
                <Column header={t("Creation_Date")} field='timeCreated' style={{width:'20%'}} sortable/>                
            </DataGrid>
            {
                crtDialog?
                <CrtDialog visible={crtDialog} onOK={onCrtDialogOK} onCancel={onCrtDialogCancel}></CrtDialog>:''
            }
        </>
    )
}